<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-xl bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col max-h-[92vh] overflow-hidden"
    (click)="$event.stopPropagation()">

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">edit</span>
          แก้ไขรายการเรียกเก็บ
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          ยอดที่กรอก/ดึงมาเป็นราคารวม VAT แล้ว — ระบบจะแยกก่อน VAT และ VAT ตอนบันทึก
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5">
      <!-- Read-only summary -->
      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 p-4 space-y-2 text-sm">
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">วันที่เรียกเก็บ</span>
          <span class="font-bold tabular-nums text-right">
            {{ row.chargeDate ? (row.chargeDate | date:'dd/MM/yyyy HH:mm') : '—' }}
          </span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">ทะเบียน</span>
          <span class="font-bold text-right">{{ row.entryLicense || '—' }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">ธุรกรรม</span>
          <span class="font-bold tabular-nums text-right">{{ row.parkingTransactionId }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">ลูกค้า</span>
          <span class="font-bold text-right">{{ row.cpCustomerName || '—' }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">กลุ่ม / เรท</span>
          <span class="font-bold text-right max-w-[60%] truncate"
            [title]="(row.groupName || '') + ' ' + (row.rateId || '') + ' ' + (row.rateName || '')">
            {{ row.groupName || '—' }}
            <span class="text-slate-400 font-medium text-xs">{{ row.rateId }} {{ row.rateName }}</span>
          </span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">เวลาเข้า / ออก</span>
          <span class="font-bold tabular-nums text-right text-xs">
            {{ row.entryDate ? (row.entryDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            →
            {{ row.exitDate ? (row.exitDate | date:'dd/MM/yyyy HH:mm') : 'ยังอยู่ในลาน' }}
          </span>
        </div>
        <div class="flex justify-between gap-3">
          <span class="text-slate-400">เวลาจอดรวม</span>
          <span class="font-bold text-right">{{ durationText(row.parkingDurationMinutes) }}</span>
        </div>
        <div class="flex justify-between gap-3" *ngIf="row.remark">
          <span class="text-slate-400">หมายเหตุ</span>
          <span class="font-medium text-right max-w-[60%]">{{ row.remark }}</span>
        </div>
      </div>

      <!-- Editable: total (VAT inclusive) -->
      <div>
        <div class="flex items-center justify-between gap-3 mb-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            ยอดรวม (รวม VAT) <span class="text-rose-500">*</span>
          </label>
          <button type="button" (click)="fetchCompanyFee()"
            [disabled]="isSaving() || isFetchingFee()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-sky-200 dark:border-sky-700 bg-sky-50 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300 text-xs font-bold hover:bg-sky-100 dark:hover:bg-sky-900/50 transition-colors cursor-pointer disabled:opacity-50">
            <span class="material-icons text-[16px]" [class.animate-spin]="isFetchingFee()">{{ isFetchingFee() ? 'sync' : 'calculate' }}</span>
            {{ isFetchingFee() ? 'กำลังดึง...' : 'ดึงราคาบริษัท' }}
          </button>
        </div>
        <div
          class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">payments</span>
          <input type="number" step="0.01" min="0" inputmode="decimal" [(ngModel)]="editTotal"
            [disabled]="isSaving() || isFetchingFee()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-bold tabular-nums focus:outline-none disabled:opacity-50">
        </div>
        <div class="mt-2 flex flex-wrap gap-3 text-xs font-semibold text-slate-500">
          <span>ก่อน VAT: <span class="tabular-nums text-sky-700 dark:text-sky-300">{{ previewFeeExVat | number:'1.2-2' }}</span></span>
          <span>VAT {{ vatSetting.rateLabel() }}%: <span class="tabular-nums text-violet-600 dark:text-violet-400">{{ previewVat | number:'1.2-2' }}</span></span>
          <span>รวม: <span class="tabular-nums text-amber-600 dark:text-amber-400">{{ editTotal | number:'1.2-2' }}</span></span>
        </div>
      </div>

      <!-- Editable: status -->
      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          สถานะ <span class="text-rose-500">*</span>
        </label>
        <div class="grid grid-cols-3 gap-2">
          <button type="button" *ngFor="let opt of statusOptions" (click)="editStatus = opt.value"
            [disabled]="isSaving()"
            class="px-2 py-2.5 rounded-xl text-xs font-bold transition-all cursor-pointer border"
            [ngClass]="editStatus === opt.value
              ? 'bg-amber-400 border-amber-400 text-slate-900 shadow-sm'
              : 'bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-amber-300'">
            {{ opt.label }}
          </button>
        </div>
        <p class="mt-2 text-[11px] text-slate-400">
          สถานะปัจจุบัน: {{ statusLabel(row.status) }}
        </p>
      </div>
    </div>

    <div class="flex-none px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 hover:border-amber-400 hover:text-amber-600 cursor-pointer bg-transparent disabled:opacity-50 inline-flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 ml-auto w-full sm:w-auto">
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 cursor-pointer bg-transparent disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="requestSave()" [disabled]="isSaving()"
        class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">
        บันทึก
      </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal
  *ngIf="showConfirm()"
  title="ยืนยันบันทึกรายการ?"
  message="จะอัปเดตยอดรวม (รวม VAT) เป็น"
  [highlight]="(editTotal | number:'1.2-2') + ' และสถานะ ' + statusLabel(editStatus)"
  [messageSuffix]="'ระบบจะแยกยอดก่อน VAT และ VAT ' + vatSetting.rateLabel() + '% อัตโนมัติ'"
  confirmLabel="ยืนยันบันทึก"
  cancelLabel="ยกเลิก"
  variant="warning"
  icon="save"
  [showIrreversibleNote]="false"
  (confirm)="confirmSave()"
  (cancel)="cancelConfirm()">
</app-pss-confirm-modal>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && row?.id"
  [entityType]="activityEntityTypes.StampBillableCharge"
  [entityId]="row.id"
  title="ประวัติรายการเรียกเก็บ Stamp"
  [subtitle]="'#' + row.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
